import {
  useFieldArray,
  UseFieldArrayRemove,
  useFormContext,
} from "react-hook-form";
import { map } from "lodash";
import SurveyFields from "./SurveyFields";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/pro-regular-svg-icons";
import Checkbox from "../../shared/form/fields/Checkbox";
import classNames from "classnames";
import ScheduleFields from "./ScheduleFields";

type QuestionTypeFieldsArgs = {
  options: string[];
  type: "schedule" | "survey";
  name: string;
  validate?: (value: any) => boolean | string;
  additionalOptionLabel: string;
};

export default function QuestionTypeFields({
  options,
  name,
  validate,
  additionalOptionLabel,
  type,
}: QuestionTypeFieldsArgs) {
  const { control, setFocus } = useFormContext();

  const methods = useFieldArray({
    control,
    name: name,
    rules: {
      validate,
    },
  });

  const { append, fields } = methods;

  const Fields = type === "schedule" ? ScheduleFields : SurveyFields;

  return (
    <>
      <div className="flex flex-col gap-2">
        <Fields
          {...methods}
          removeButton={(index: number) => (
            <RemoveOptionButton
              index={index}
              remove={methods.remove}
              className={classNames("", {
                "shrink-0 text-muted": type === "survey",
              })}
            />
          )}
        />
        <button
          type="button"
          className="flex btn gap-1 justify-start items-center text-muted border-box hover:text-muted hover:border-box"
          onClick={(e) => {
            e.preventDefault();
            const newIndex = fields.length;
            append({ label: "" });
            setTimeout(() => setFocus(`${name}.${newIndex}`), 0);
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
          {additionalOptionLabel}
        </button>
      </div>
      <div>
        {map(options, (option) => (
          <Checkbox
            key={option}
            name={`object.${option}`}
            label={I18n.t(
              `js.activitystreams.composer.${type}.options.${option}`,
            )}
          />
        ))}
      </div>
    </>
  );
}

function RemoveOptionButton({
  index,
  remove,
  className = "",
}: {
  index: number;
  remove: UseFieldArrayRemove;
  className?: string;
}) {
  return (
    <button
      className={className}
      type="button"
      onClick={(e) => {
        e.preventDefault();
        remove(index);
      }}
    >
      <FontAwesomeIcon icon={faXmark} />
    </button>
  );
}
